module.exports = __webpack_public_path__ + "static/media/thumbnail-drcleanaustralia.98d02323.jpg";